import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { canOpenRoute } from "../lib/roles";

/**
 * ProtectedRoute — for INTERNAL routes only (Admin/Employee).
 *
 * Behaviour matrix:
 *   user === null       loading spinner
 *   user === false      → /login
 *   user.principal_type === "customer"  → /portal    (customers never see internal UI)
 *   user is internal + hits an admin-only path with role !== admin  → /
 */
export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-zinc-500">Lade…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.principal_type === "customer") return <Navigate to="/portal" replace />;

  if (!canOpenRoute(user, location.pathname)) {
    return <Navigate to="/" replace state={{ denied: location.pathname }} />;
  }
  return children;
}
